export default __webpack_public_path__ + "static/media/director.c080616a.png";